import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import {
  allActividadesExtrasAction,
  setActivoActividadesExtrasAction,
} from './ActividadesExtrasAction';
import FormActividadesExtras from './components/FormActividadesExtras';
import ListadoActividadesExtras from './components/ListadoActividadesExtras';

const ActividadesExtrasView = () => {
  const dispatch = Redux.useDispatch();

  const actividadesExtrasStore = Redux.useSelector(
    (state) => state.actividadesExtras,
  );

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoActividadesExtrasAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          mr={2}
          addIcon
          text="ASIGNAR"
        />
        <BotonComponent
          click={async () => {
            await setActivoActividadesExtrasAction(dispatch, null);
            await allActividadesExtrasAction(
              dispatch,
              actividadesExtrasStore.params,
            );
          }}
          disabled={
            actividadesExtrasStore.all.length === 0 ||
            actividadesExtrasStore.loadingAll
          }
          white
          refreshIcon
          text={
            actividadesExtrasStore.loadingAll ? 'Actualizando...' : 'Actualizar'
          }
        />
      </Grid>
      <Grid item md={12}>
        <ListadoActividadesExtras
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </Grid>
      <ModalComponent
        id="modalFormActividadesExtras"
        title={`${
          actividadesExtrasStore.activo
            ? `Editar actividad extra: ${actividadesExtrasStore.activo.nombre}`
            : 'Nueva actividad extra'
        }`}
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormActividadesExtras
          activo={actividadesExtrasStore.activo}
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default ActividadesExtrasView;
